import * as Constants from '@rideiq/constants';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface RidesTablePrefsStore {
  perPage: number;
  setPerPage: (perPage: number) => void;
}

export const useRidesTablePrefsStore = create<RidesTablePrefsStore>()(
  persist(
    (set) => ({
      perPage: Constants.DEFAULT_ROWS_PER_PAGE,
      setPerPage: (perPage) => set({ perPage }),
    }),
    { name: 'ridesTablePrefs', storage: createJSONStorage(() => localStorage) }
  )
);
